'use strict';

DoohApps.factory('UploadFileStorage', [
    'DialogHandler',
    'MediaAssets',
    'DoohHelper',
    function (DialogHandler, MediaAssets, DoohHelper) {
        var files = [];

        return {
            SetFiles: function (_files, maxVideoSize, maxImgSize) {
                maxVideoSize = parseInt(maxVideoSize);
                maxImgSize = parseFloat(maxImgSize);
                files = [];
                angular.forEach(_files, function (v, k) {
                    var fileType = v.type.split('/')[0];
                    if (!DoohHelper.validateFileExtention(v.type, v.name)) {
                        DialogHandler.AddError('Unsupported file format: ' + v.name);
                    } else if (maxVideoSize > 0 && fileType === 'video' && v.size > maxVideoSize) {
                        DialogHandler.AddError('File too big: ' + v.name);
                    } else if (maxImgSize > 0 && fileType === 'image' && v.size > maxImgSize) {
                        DialogHandler.AddError('File too big: ' + v.name);
                    } else {
                        files.push(v);
                    }
                });
            },
            GetFiles: function () {
                return files;
            },
            HasFiles: function () {
                return files.length > 0;
            },
            ResetStorage: function () {
                files = [];
            }
        };
    }
]);
